module.exports = __webpack_public_path__ + "static/img/1@2x.9893489c.png";